<template>
  <main
      id="index" class="overflow-y-hidden relative"
  >
    <!--    <loco-modal>-->
    <!--      <img src="@/assets/images/pages/main/voiceVideo/voice3.png" alt="" class="fixed top-0 w-full lg:w-3/4">-->
    <!--    </loco-modal>-->
    <!--hero section    -->
    <hero ref="hero" @hook:mounted="refUpdated('hero')"/>

    <!--trailer section    -->
    <trailer ref="trailer" @hook:mounted="refUpdated('trailer')"/>

    <!-- token section   -->
    <token ref="token" @hook:mounted="refUpdated('token')"/>

    <!--  play to earn section  -->
    <play-to-earn ref="pte" @hook:mounted="refUpdated('pte')"/>


    <!-- clean to earn section    -->
    <clean-to-earn ref="cte" @hook:mounted="refUpdated('cte')"/>


    <!-- ugc section   -->
    <ugc ref="ugc" @hook:mounted="refUpdated('ugc')"/>


    <!-- seedBox section   -->
    <seed-box ref="seed-box" @hook:mounted="refUpdated('seed-box')"/>


    <!-- voice video chat section   -->
    <voice-video ref="voice-video" @hook:mounted="refUpdated('voice-video')"/>


    <!-- dao section   -->
    <dao ref="dao" @hook:mounted="refUpdated('dao')"/>

    <!-- map section   -->
    <the-map ref="the-map" @hook:mounted="refUpdated('the-map')"/>

    <!-- nft collection section   -->
    <nft ref="nft" @hook:mounted="refUpdated('nft')"/>

    <!-- pfp collection section   -->
    <pfp ref="pfp" @hook:mounted="refUpdated('pfp')"/>

    <!-- nft market section   -->
    <nft-market ref="nft-market" @hook:mounted="refUpdated('nft-market')"/>

    <!--road map section   -->
    <road-map ref="road-map" @hook:mounted="refUpdated('road-map')"/>

    <!--team section   -->
    <!--    <team ref="team" @hook:mounted="refUpdated('team')"/>-->

    <!--partner section   -->
    <partner ref="partner" @hook:mounted="refUpdated('partner')"/>

    <!--investor section   -->
    <listed ref="listed" @hook:mounted="refUpdated('listed')"/>

    <the-footer/>
  </main>
</template>

<script>
// import BackToTop from '@/views/components/BackToTop'
import Logo from '@/components/logo/Logo'
import Hero from '@/views/components/Hero'
import Trailer from '@/views/components/Trailer'
import Token from '@/views/components/Token'
import PlayToEarn from '@/views/components/PlayToEarn'
import CleanToEarn from '@/views/components/CleanToEarn'
import Ugc from '@/views/components/Ugc'
import SeedBox from '@/views/components/SeedBox'
import VoiceVideo from '@/views/components/VoiceVideo'
import Dao from '@/views/components/Dao'
import TheMap from '@/views/components/TheMap'
import Nft from '@/views/components/Nft'
import Pfp from '@/views/components/Pfp'
import NftMarket from '@/views/components/NftMarket'
import RoadMap from '@/views/components/RoadMap'
import Team from '@/views/components/Team'
import Partner from '@/views/components/Partner'
import Listed from '@/views/components/Listed'
import LocomotiveScroll from 'locomotive-scroll'
import {EventBus} from '../../EventBus'
import TheFooter from '@/layouts/components/TheFooter'
import _ from 'lodash'
import LocoModal from '../components/LocoModal'

let locoScroll = null
export default {
  name: 'index',
  components: {
    LocoModal,
    // BackToTop,
    TheFooter,
    Listed,
    Partner,
    Logo,
    Hero,
    Trailer,
    Token,
    PlayToEarn,
    CleanToEarn,
    Ugc,
    SeedBox,
    VoiceVideo,
    Dao,
    TheMap,
    Nft,
    Pfp,
    NftMarket,
    RoadMap
    // Team
  },
  data: () => ({
    names: []
  }),
  computed: {
    scroller (a) {
      return document.getElementById('index')
    }
  },
  methods: {
    updateY: _.throttle(function (arg) {
      this.$store.commit('UPDATE_WINDOW_SCROLL_DIRECTION', arg.direction)
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', arg.scroll.y)
    }, 300),
    refUpdated (name) {
      this.names.push(name)
    },
    initLocoScroll () {
      if (window.locoScroll) {
        window.locoScroll.destroy()
        window.locoScroll = null
      }

      window.locoScroll = locoScroll = new LocomotiveScroll({
        el: this.scroller,
        lerp: 0.01, //0.08
        inertia: 0.6,
        smooth: true,
        multiplier: 1.4, // Effect Multiplier
        reloadOnContextChange: true,
        touchMultiplier: 3.4,
        smartphone: {
          smooth: true,
          breakpoint: 767
        },
        getSpeed: true,
        useKeyboard: true,
        tablet: {
          breakpoint: 1024,
          smooth: true
        },
        smoothMobile: true,
        getDirection: true
      })

      locoScroll.on('scroll', this.scrollLoco)
      this.$scrollTrigger.scrollerProxy(this.scroller, {
        scrollTop: (value) => {
          return arguments.length ?
              locoScroll.scrollTo(value, 0, 0) :
              locoScroll.scroll.instance.scroll.y
        },
        getBoundingClientRect () {
          return {
            left: 0, top: 0,
            width: window.innerWidth,
            height: window.innerHeight
          }
        },
        pinType: this.scroller.style.transform ? 'transform' : 'fixed'
      })

      EventBus.$on('scrollTo', (obj) => {
        if (obj) {
          locoScroll.scrollTo(obj)
        } else {
          locoScroll.scrollTo(this.scroller)
        }
      })

      this.$scrollTrigger.addEventListener('refresh', this.scrollTriggerRefreshed)
    },
    scrollTriggerRefreshed () {
      this.$scrollTrigger.sort()
      locoScroll.update()
    },
    scrollLoco (...args) {
      this.updateY(...args)
      this.$scrollTrigger.update(...args)
    }
  },
  created () {
  },
  mounted () {
    this.initLocoScroll()
    this.names.forEach((ref) => {
      if (this.$refs[ref].animations) {
        this.$refs[ref].animations()
      }
    })

    EventBus.$emit('loaded')
    this.$store.commit('SET_APP_CLASSES', ['bg-black'])

    this.$scrollTrigger.refresh()

    if (this.$scrollTrigger) {
      this.$nextTick(() => {
        locoScroll.scrollTo('bottom', {
          duration: 0,
          disableLerp: true,
          callback: () => {
            locoScroll.scrollTo('top', {
              duration: 0,
              disableLerp: true,
              callback: () => {
                this.$scrollTrigger.refresh()
                const resizeObserver = new ResizeObserver(() => {
                  this.$scrollTrigger.refresh()
                })
                resizeObserver.observe(document.getElementById('index'))

                const appLoading = document.getElementById('loading-bg')
                if (appLoading) {
                  appLoading.style.display = 'none'
                }
              }
            })
          }
        })
      })
    }
  },
  beforeDestroy () {
    this.$scrollTrigger.removeEventListener('refresh', this.scrollTriggerRefreshed)
  }
}
</script>

<style scoped lang="scss">
main::v-deep {
  overflow-x: hidden;
  // .test에 마우스가 올라가면 유리에 빛이 비치며 지나가는 효과
  .test {
    position: relative;
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.1);
      z-index: -1;
      transition: all 0.3s ease;
    }

    &:hover {
      &:before {
        background: rgba(255, 255, 255, 0.3);
      }
    }
  }
}
</style>
